import { useRef } from 'react';

import { GraphQLResolver } from '../core/graphql-resolver';

export const graphQlResolver = new GraphQLResolver('federatedGraphQL');

export function useFederatedGraphQL() {
  const graphQlClient = useRef(graphQlResolver.resolve());

  return graphQlClient.current;
}
